export default "__VITE_ASSET__Cc9Lq4xk__"